import { render } from "./IconHistory.vue?vue&type=template&id=a58ae3c8"
import script from "./IconHistory.vue?vue&type=script&lang=js"
export * from "./IconHistory.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__